import React from "react";

interface ResetSentProps {
  email: string;
  onBackToSignIn: () => void;
}

export default function ResetSent({ email, onBackToSignIn }: ResetSentProps) {
  return (
    <div className="text-center">
      <div className="mb-4">
        <svg
          width="48"
          height="48"
          viewBox="0 0 24 24"
          fill="none"
          stroke="#0d6efd"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          aria-hidden="true"
        >
          <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
          <polyline points="22,6 12,13 2,6" />
        </svg>
      </div>

      <h1 className="h3 fw-bold text-dark mb-1">Check your email</h1>
      <p className="text-muted mb-4">
        If an account exists for <strong>{email}</strong>, we&apos;ve sent a
        link to reset your password.
      </p>

      <button
        type="button"
        className="btn btn-outline-primary btn-lg w-100"
        onClick={onBackToSignIn}
      >
        Back to sign in
      </button>
    </div>
  );
}
